import {
	IonIcon,
	IonRouterLink,
} from '@ionic/react'
import { informationCircleOutline } from 'ionicons/icons'
import React, { useContext } from 'react'

import { useSetHelpTab } from './data'
import { ModalContext } from './ModalContext'
import { ProfileContext } from './ProfileContext'

type MoreInfoLinkProps = {
	helpSection: string
	helpSubSection?: string
	text: string
	routerDirection?: 'forward' | 'back' | 'root' | 'none'
	onClick?: () => void
}

export const MoreInfoLink = (props: MoreInfoLinkProps) => {

	const setHelpTab = useSetHelpTab()
	const closeSideMenu = useContext(ProfileContext)
	const onDismiss = useContext(ModalContext)

	const url = `/help#${props.helpSection}${props.helpSubSection ? '-' + props.helpSubSection : ''}`

	return (
		<IonRouterLink
			className="more-info-link"
			routerLink={url}
			routerDirection={props.routerDirection}
			onClick={() => {
				props.onClick?.()
				onDismiss()
				closeSideMenu()
				setHelpTab(props.helpSection)
			}}
		>
			<IonIcon
				className="more-info-link-icon"
				icon={informationCircleOutline}
			/>
			{props.text}
		</IonRouterLink>
	)
}
